import React from "react";

const NonAuth = (props) => {
  return <div>{props.children}</div>;
};

export default NonAuth;
